// @Host Management
// 10-07-2025
import { ADD_HOST_IDS, HOST_SELECTED, RESET_HOST } from "./actionTypes";
const INIT_STATE = {
  selectedHostId: "",
  hostIds: [],
};

const HostTechManagement = (state = INIT_STATE, action) => {
  switch (action.type) {
    case RESET_HOST:
      return {
        selectedHostId: "",
        hostIds: [],
      };

    case HOST_SELECTED:
      return {
        ...state,
        selectedHostId: action.payload,
      };
    case ADD_HOST_IDS:
      return {
        ...state,
        hostIds: action.payload,
      };

    default:
      return state;
  }
};
export default HostTechManagement;
